"use strict";
// This file sets up functionality and behavior for nav dropdowns without hover and the menu on mobile.


function toggleMobileMenu() {
	this.toggle.classList.toggle("is-open");
	this.nav.classList.toggle("is-open");
}

function setHidden(el) {
	el.classList.remove("is-visible");
	el.classList.add("is-hidden");
}

function setVisible(el) {
	el.classList.remove("is-hidden");
	el.classList.add("is-visible");
}

function toggleNavItem() {

	var clicked_submenu = this.clicked_el.querySelector(".sub-menu");
	var submenus = this.submenus.els;

	if ( clicked_submenu.classList.contains("is-visible") ) {
		setHidden(clicked_submenu);
	} else {
		for(var k=0; k<submenus.length; k++) {
			if (submenus[k] != clicked_submenu) {
				setHidden(submenus[k]);
			}
		}

		setVisible(clicked_submenu);
	}

}

function setupMobileMenu() {
	var mobile_menu = {
		toggle: document.querySelector("#mobile-menu-toggle"),
		nav: document.querySelector("#main-nav")
	};

	mobile_menu.toggle.addEventListener("click", toggleMobileMenu.bind(mobile_menu), false);
}


function setupNavItems() {
	var submenus = {
		els: document.querySelectorAll("#main-nav .sub-menu"),
		li_els: document.querySelectorAll("#main-nav li.menu-item-has-children")
	};

	for(let i=0; i<submenus.li_els.length; i++) {
		let current_submenu = {
			submenus: submenus,
			clicked_el: submenus.li_els[i]
		};
		submenus.li_els[i].addEventListener("click", toggleNavItem.bind(current_submenu), false);
	}
}

setupMobileMenu();
setupNavItems();
